import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { Customer } from '@klickdata/core/customer';
import { Resource, ResourceCategory, ResourceTag, ResourceTypes } from '@klickdata/core/resource';
import { ResourceItem } from '@klickdata/core/resource-item';
import { User } from '@klickdata/core/user';
import moment from 'moment';
import { Observable } from 'rxjs';
import { ResourceDetailsInfoComponent } from '../resource-details-info/resource-details-info.component';
import { Utils } from '@klickdata/core/util';
import { ResourceDetailsActionBtn } from '@klickdata/core/util/src/utils';
import { OccasionDate } from '@klickdata/core/resource/src/resource.model';

@Component({
    selector: 'app-resource-details-base',
    templateUrl: './resource-details-base.component.html',
    styleUrls: ['./resource-details-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceDetailsBaseComponent {
    @Input() resource: Resource;
    @Input() user: User;
    @Input() customer: Customer;
    @Input() resourceItems: ResourceItem[];
    @Input() resourceCategories$: Observable<ResourceCategory[]>;
    @Input() resourceTags$: Observable<ResourceTag[]>;
    @Input() resourceType: ResourceTypes;
    @ViewChild(ResourceDetailsInfoComponent) infoComp: ResourceDetailsInfoComponent;
    ResourceTypes = ResourceTypes;
    public moment = moment();
    constructor() {}

    public get resourceActionBtn(): ResourceDetailsActionBtn {
        if (
            ResourceTypes.parentType(this.resource.type_id) === ResourceTypes.COURSE ||
            ResourceTypes.parentType(this.resource.type_id) === ResourceTypes.EVENT
        ) {
            return Utils.getResourceDetailsActionBtnOptions(
                this.resource.opportunity_id,
                this.resource.user_collaboration?.enroll_approval_required?.metadata?.occasion_dates,
                this.resource.user_collaboration?.enroll_approval_required?.status,
                this.resource.enrollment?.approval_status
            );
        } else {
            return {
                label: this.resource.opportunity_id ? $localize`Continue` : $localize`Start`,
                type: this.resource.opportunity_id ? 'continue' : 'take',
                icon: this.resource.opportunity_id ? 'double_arrow' : 'play_arrow',
            };
        }
    }
    public get occasionDates(): OccasionDate[] {
        const dates = this.resource.user_collaboration?.enroll_approval_required?.metadata?.occasion_dates;
        return !!dates?.length ? Utils.filterEmptyOccasionDates(dates) : [];
    }
}
